/*
Copyright 2025 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export interface ParsedParticipantIdentity {
  userId: string;
  deviceId: string;
}

/**
 * Разбирает LiveKit identity формата `${userId}:${deviceId}`.
 */
export function parseParticipantIdentity(
  identity: string | undefined,
): ParsedParticipantIdentity | null {
  if (!identity) {
    return null;
  }

  const separatorIndex = identity.lastIndexOf(":");
  if (separatorIndex < 0) {
    return null;
  }

  const userId = identity.slice(0, separatorIndex);
  const deviceId = identity.slice(separatorIndex + 1);

  if (!userId.startsWith("@") || deviceId.length === 0) {
    return null;
  }

  return { userId, deviceId };
}

/**
 * Возвращает все поддерживаемые state key для membership события MatrixRTC.
 */
export function getRtcMembershipStateKeys(
  userId: string,
  deviceId: string,
): string[] {
  const suffix = `${userId}_${deviceId}_m.call`;
  return [`_${suffix}`, suffix];
}
